<script setup>
import DiscoverContent from "@core/components/DiscoverContent.vue"
</script>

<template>
  <div>
    <section class="mt-0">
      <DiscoverContent />
    </section>
  </div>
</template>


